import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Button, Modal, Col, Row, Form, Tab, Tabs } from 'react-bootstrap'
import settings from '../../../../setting'
import InputText from '../../../commons/form/InputText'
import InputMoney from '../../../commons/form/InputMoney'
import InputSelect from '../../../commons/form/InputSelect'
import InputCheckBox from '../../../commons/form/InputCheckBox'
import InputDatePicker from '../../../commons/form/InputDatePicker'
import InputPercentage from '../../../commons/form/InputPercentage'
import { campaignType, campaignField } from '../../../../constants/dossier/common/campaignType'
import { validateDate } from '../../../../util/validationFunctions'
import { permissions } from '../../../../constants/backendIds'
import { getFieldsPermisions } from '../../../../util/permisionFunctions'
import CampaignsPopover from '../../common/CampaignsPopover'

class CampaignsModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      typeId: props.editedCampaign && props.editedCampaign.typeId || null,
      dossierSubTypeId: props.editedCampaign && props.editedCampaign.dossierSubTypeId || null,
      cost: 0,
      costConcession: 0,
      tabActiveKey: 1,
      fieldsConfiguration: {
        costConcession: {
          permission: null
        },
        amountPercentage: {
          permission: null
        },
        costPercentage: {
          permission: null
        },
        costConcessionPercentage: {
          permission: null
        },
        popOverCampaings: {
          permission: null
        },
        name: {
          permission: null
        },
        amount: {
          permission: null
        },
        cost: {
          permission: null
        },
        expirationDate: {
          permission: null
        },
        documentIds: {
          permission: null
        },
        supInvoice: {
          permission: null
        },
        dossierSubTypeId: {
          permission: null
        },
        provider: {
          permission: null
        }
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  UNSAFE_componentWillMount () {
    if (this.props.componentConfiguration) {
      this.initializePermisions(this.props)
    } else {
      this.setState({ permission: 0 })
    }
  }

  onDossierSubTypeIdChanges (dossierSubTypeId) {
    this.setState({ dossierSubTypeId })
  }

  submitCampaign (values) {
    values.form = 'campaign_modal'
    if (this.state.tabActiveKey === 1) {
      values.costPercentage = null
      values.costConcessionPercentage = null
      values.amountPercentage = null
    } else {
      values.cost = null
      values.costConcession = null
      values.amount = null
    }
    if (values.dossierSubTypeId === campaignType.CAMPAIGN) {
      values.provider = null
      values.supInvoice = null
    }
    if (values.campaignId) {
      this.props.actions.updateCampaign(values, this.props.actions.closeModal)
    } else {
      this.props.actions.createCampaign(values, this.props.actions.closeModal)
    }
  }

  setAmount (value) {
    this.setValue(campaignField.AMOUNT, value)
  }

  setCost (value) {
    let cost = this.setValue(campaignField.COST, value)
    this.setState({ cost: cost })
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.calculateAmount(cost, this.state.costConcession)
    }
  }

  setCostConcession (value) {
    let costConcession = this.setValue(campaignField.COST_CONCESSION, value)
    this.setState({ costConcession: costConcession })
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.calculateAmount(this.state.cost, costConcession)
    }
  }

  setValue (field, value) {
    let total = 0
    if (this.props.vehicleAmount) {
      total = (((this.props.vehicleAmount) * value) / 100).toFixed(2)
    }
    this.props.change(field, total)
    return total
  }

  setPercentage (field, value) {
    let total = 0
    if (this.props.vehicleAmount) {
      total = ((value * 100) / (this.props.vehicleAmount)).toFixed(2)
    } else if (this.props.editedCampaign && (this.props.editedCampaign.costPercentage || this.props.editedCampaign.costConcessionPercentage)) {
      total = parseFloat(this.props.editedCampaign.costPercentage || 0) + parseFloat(this.props.editedCampaign.costConcessionPercentage || 0)
    }
    this.props.change(field, total)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return JSON.stringify(nextProps) !== JSON.stringify(this.props) || JSON.stringify(nextState) !== JSON.stringify(this.state)
  }

  componentDidUpdate (prevProps) {
    if (this.props.editedCampaign && prevProps.editedCampaign && prevProps.editedCampaign.dossierSubTypeId !== this.props.editedCampaign.dossierSubTypeId && this.state.dossierSubTypeId !== this.props.editedCampaign.dossierSubTypeId) {
      this.setState({ dossierSubTypeId: this.props.editedCampaign.dossierSubTypeId })
    }
    if (this.props.editedCampaign && prevProps.editedCampaign && prevProps.editedCampaign.typeId !== this.props.editedCampaign.typeId && this.state.typeId !== this.props.editedCampaign.typeId) {
      this.setState({ typeId: this.props.editedCampaign.typeId })
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.showModal && nextProps.showModal) {
      this.initializePermisions(nextProps)
      this.props.initialize(nextProps.campaignSelected)
      const cost = nextProps && nextProps.campaignSelected && nextProps.campaignSelected.cost ? nextProps.campaignSelected.cost : 0
      const amount = nextProps && nextProps.campaignSelected && nextProps.campaignSelected.amount ? nextProps.campaignSelected.amount : 0
      this.setState({ cost: cost, costConcession: (parseFloat(amount) - parseFloat(cost)) })
      if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
        this.props.change('costConcession', parseFloat(amount) - parseFloat(cost))
      }
      if (this.state.fieldsConfiguration.amountPercentage !== permissions.hidden ||
        this.state.fieldsConfiguration.costPercentage !== permissions.hidden ||
        this.state.fieldsConfiguration.costConcessionPercentage !== permissions.hidden) {
        if (nextProps.campaignSelected.costPercentage || nextProps.campaignSelected.costConcessionPercentage || nextProps.campaignSelected.amountPercentage) {
          this.setState({ tabActiveKey: 2 })
          this.setCostConcession(nextProps.campaignSelected.costConcessionPercentage)
          this.setCost(nextProps.campaignSelected.costPercentage)
          this.setAmount(nextProps.campaignSelected.costPercentage + nextProps.campaignSelected.costConcessionPercentage)
          this.props.change('amountPercentage', nextProps.campaignSelected.costPercentage + nextProps.campaignSelected.costConcessionPercentage)
        } else {
          this.setState({ tabActiveKey: 1 })
          this.setPercentage(campaignField.AMOUNT_PERCENTAGE, amount)
          this.setPercentage(campaignField.COST_PERCENTAGE, cost)
          this.setPercentage(campaignField.COST_CONCESSION_PERCENTAGE, parseFloat(amount) - parseFloat(cost))
        }
      }
    }
    if (this.props.showModal && !nextProps.showModal) {
      this.props.reset('campaign_modal')
    }
  }

  calculateAmount (cost, costConcession) {
    this.props.change('amount', parseFloat(cost) + parseFloat(costConcession))
    this.handleBlurAmount(parseFloat(cost) + parseFloat(costConcession))
  }

  handleBlurCost (event) {
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.setState({ cost: event })
      this.calculateAmount(event, this.state.costConcession)
    }
    if (this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden) {
      this.setPercentage(campaignField.COST_PERCENTAGE, event)
    }
  }

  handleBlurCostConcession (event) {
    if (this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden) {
      this.setState({ costConcession: event })
      this.calculateAmount(this.state.cost, event)
    }
    if (this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden) {
      this.setPercentage(campaignField.COST_CONCESSION_PERCENTAGE, event)
    }
  }

  handleBlurAmount (event) {
    if (this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden) {
      this.setPercentage(campaignField.AMOUNT_PERCENTAGE, event)
    }
  }

  handleBlurAmountPercentage (event) {
    if (this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden) {
      this.setAmount(event)
    }
  }

  handleBlurCostPercentage (event) {
    if (this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden) {
      this.setCost(event)
    }
  }

  handleBlurCostConcessionPercentage (event) {
    if (this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden) {
      this.setCostConcession(event)
    }
  }

  validateDate (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  render () {
    const { t, showModal, handleSubmit, actions: { closeModal }, combos: { campaignsTypes, documentsTypes, dossierSubTypesCombo }, secondClass } = this.props
    const tKey = 'DOSSIER_COMPONENTS.CAMPAIGNS.CAMPAIGNS_MODAL.'
    return (
      <Modal show={showModal} onHide={() => closeModal()} backdrop={'static'} className={secondClass ?? ''}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.submitCampaign.bind(this))}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              {this.state.fieldsConfiguration.name.permission !== permissions.hidden && (
                <Field
                  id="name"
                  name="name"
                  colSm={this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden ? 12 : 6}
                  controlLabel={t(`${tKey}NAME`)}
                  placeholder={t(`${tKey}NAME`)}
                  component={InputText}
                />
              )}

              {this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden ? (
                <div className="clearfix"/>,
                <Tabs
                  id="1"
                  defaultActiveKey={1}
                  activeKey={this.state.tabActiveKey}
                  onSelect={tabActiveKey => this.setState({ tabActiveKey })}>
                  <Tab eventKey={1} title={t(`${tKey}INTRODUCE_AMOUNT`)} className="dossier-tab">
                    {this.state.fieldsConfiguration.amount.permission !== permissions.hidden && (
                      <Field
                        id="amount_amount"
                        name="amount"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}AMOUNT`)}
                        placeholder={t(`${tKey}AMOUNT`)}
                        component={InputMoney}
                        disabled={this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden}
                        onInputBlur={(event) => this.handleBlurAmount(event)}
                      />
                    )}
                    {this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amount_amountPercentage"
                        name="amountPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}AMOUNT_PERCENTAGE`)}
                        placeholder={t(`${tKey}AMOUNT_PERCENTAGE`)}
                        component={InputPercentage}
                        popOver={ this.state.fieldsConfiguration.popOverCampaings.permission !== permissions.hidden ? <CampaignsPopover id="campaignsPopover" name="campaignsPopover" key="campaignsPopover" t={t} text={t(`${tKey}AMOUNT_PERCENTAGE`) } /> : null}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.cost.permission !== permissions.hidden && (
                      <Field
                        id="amount_cost"
                        name="cost"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST`)}
                        placeholder={t(`${tKey}COST`)}
                        component={InputMoney}
                        onInputBlur={(event) => this.handleBlurCost(event)}
                      />
                    )}
                    {this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amount_costPercentage"
                        name="costPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST_PERCENTAGE`)}
                        placeholder={t(`${tKey}COST_PERCENTAGE`)}
                        component={InputPercentage}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="amount_costConcession"
                        name="costConcession"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST_CONCESSION`)}
                        placeholder={t(`${tKey}COST_CONCESSION`)}
                        component={InputMoney}
                        onInputBlur={(event) => this.handleBlurCostConcession(event)}
                      />)}
                    {this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden &&
                      this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="amount_costConcessionPercentage"
                        name="costConcessionPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST_CONCESSION_PERCENTAGE`)}
                        placeholder={t(`${tKey}COST_CONCESSION_PERCENTAGE`)}
                        component={InputPercentage}
                        disabled={true}
                      />)}
                  </Tab>
                  <Tab eventKey={2} title={t(`${tKey}INTRODUCE_PERCENTAGE`)} className="dossier-tab">
                    {this.state.fieldsConfiguration.amount.permission !== permissions.hidden && (
                      <Field
                        id="amount"
                        name="amount"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}AMOUNT`)}
                        placeholder={t(`${tKey}AMOUNT`)}
                        component={InputMoney}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.amountPercentage.permission !== permissions.hidden && (
                      <Field
                        id="amountPercentage"
                        name="amountPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}AMOUNT_PERCENTAGE`)}
                        placeholder={t(`${tKey}AMOUNT_PERCENTAGE`)}
                        component={InputPercentage}
                        popOver={ this.state.fieldsConfiguration.popOverCampaings.permission !== permissions.hidden ? <CampaignsPopover id="campaignsPopover" name="campaignsPopover" key="campaignsPopover" t={t} text={t(`${tKey}AMOUNT_PERCENTAGE`) } /> : null}
                        disabled={this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden}
                        onInputBlur={(component) => this.handleBlurAmountPercentage(component)}
                      />
                    )}
                    {this.state.fieldsConfiguration.cost.permission !== permissions.hidden && (
                      <Field
                        id="cost"
                        name="cost"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST`)}
                        placeholder={t(`${tKey}COST`)}
                        component={InputMoney}
                        disabled={true}
                      />
                    )}
                    {this.state.fieldsConfiguration.costPercentage.permission !== permissions.hidden && (
                      <Field
                        id="costPercentage"
                        name="costPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST_PERCENTAGE`)}
                        placeholder={t(`${tKey}COST_PERCENTAGE`)}
                        component={InputPercentage}
                        onInputBlur={(component) => this.handleBlurCostPercentage(component)}
                      />
                    )}
                    {this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="costConcession"
                        name="costConcession"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST_CONCESSION`)}
                        placeholder={t(`${tKey}COST_CONCESSION`)}
                        component={InputMoney}
                        disabled={true}
                      />)}
                    {this.state.fieldsConfiguration.costConcessionPercentage.permission !== permissions.hidden &&
                      this.state.fieldsConfiguration.costConcession.permission !== permissions.hidden && (
                      <Field
                        id="costConcessionPercentage"
                        name="costConcessionPercentage"
                        type="text"
                        colSm={6}
                        controlLabel={t(`${tKey}COST_CONCESSION_PERCENTAGE`)}
                        placeholder={t(`${tKey}COST_CONCESSION_PERCENTAGE`)}
                        component={InputPercentage}
                        onInputBlur={(component) => this.handleBlurCostConcessionPercentage(component)}
                      />)}
                  </Tab>
                </Tabs>) : ([
                this.state.fieldsConfiguration.amount.permission !== permissions.hidden && (
                  <Field
                    id="amount"
                    key="amount"
                    name="amount"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}AMOUNT`)}
                    placeholder={t(`${tKey}AMOUNT`)}
                    component={InputMoney}
                  />
                ),
                this.state.fieldsConfiguration.cost.permission !== permissions.hidden && (
                  <Field
                    id="cost"
                    key="cost"
                    name="cost"
                    type="text"
                    colSm={6}
                    controlLabel={t(`${tKey}COST`)}
                    placeholder={t(`${tKey}COST`)}
                    component={InputMoney}
                  />
                )
              ])}
              {this.state.fieldsConfiguration.dossierSubTypeId.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="dossierSubTypeId"
                  name="dossierSubTypeId"
                  controlLabel={t(`${tKey}CAMPAIGN_TYPE`)}
                  placeholder={t(`${tKey}CAMPAIGN_TYPE`)}
                  component={InputSelect}
                  options={dossierSubTypesCombo}
                  valueKey="id"
                  labelKey="value"
                  onInputChange={this.onDossierSubTypeIdChanges.bind(this)}
                  disabled={!!(this.props.editedCampaign && this.props.editedCampaign.campaignId)}
                />
              )}
              {(settings.clientEnviroment !== 'quadis' || settings.clientEnviroment === 'quadis' && this.state.dossierSubTypeId === campaignType.CAMPAIGN) ? (
                <Field
                  colSm={6}
                  id="typeId"
                  name="typeId"
                  controlLabel={t(`${tKey}CAMPAIGN_SUBTYPE`)}
                  placeholder={t(`${tKey}CAMPAIGN_SUBTYPE`)}
                  component={InputSelect}
                  options={campaignsTypes}
                  valueKey="id"
                  labelKey="value"
                />
              ) : null }
              {this.state.dossierSubTypeId !== campaignType.CAMPAIGN ? (
                this.state.fieldsConfiguration.provider.permission !== permissions.hidden && (
                  <Field
                    id="provider"
                    name="provider"
                    colSm={6}
                    controlLabel={t(`${tKey}PROVIDER`)}
                    placeholder={t(`${tKey}PROVIDER`)}
                    component={InputText}
                  />
                )
              ) : (
                this.state.fieldsConfiguration.expirationDate.permission !== permissions.hidden && (
                  <Field
                    id="expirationDate"
                    name="expirationDate"
                    colSm={6}
                    controlLabel={t(`${tKey}EXPIRATION_DATE`)}
                    component={InputDatePicker}
                    validate={[this.validateDate]}
                  />
                )
              )}
              {this.state.fieldsConfiguration.documentIds.permission !== permissions.hidden && (
                <Field
                  colSm={6}
                  id="documentIds"
                  name="documentIds"
                  controlLabel={t(`${tKey}CHECKLIST`)}
                  placeholder={t(`${tKey}CHECKLIST`)}
                  component={InputSelect}
                  options={documentsTypes}
                  valueKey="id"
                  labelKey="value"
                  multi
                  placement="top"
                />
              )}
              { this.state.dossierSubTypeId !== campaignType.CAMPAIGN && ([
                this.state.fieldsConfiguration.expirationDate.permission !== permissions.hidden && (
                  <Field
                    key="expirationDate"
                    id="expirationDate"
                    name="expirationDate"
                    colSm={6}
                    controlLabel={t(`${tKey}EXPIRATION_DATE`)}
                    component={InputDatePicker}
                    validate={[this.validateDate]}
                    placement="top"
                  />

                ),
                <Col sm={6} className="col-row input-group-row" key="supInvoice">
                  {this.state.fieldsConfiguration.supInvoice.permission !== permissions.hidden && (
                    <Field
                      id="supInvoice"
                      name="supInvoice"
                      colSm={12}
                      inline
                      placeholder={t(`${tKey}SUPPLEMENTARY_INVOICE`)}
                      component={InputCheckBox}
                    />
                  )}
                </Col>
              ])}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={6} className="btn-wrapper">
              <Button id="btn_save" className="btn-standard" type="submit">{t(`${tKey}SAVE_BTN`)}</Button>
            </Col>
            <Col sm={6} className="btn-wrapper">
              <Button id="btn_cancel" className="btn-standard btn-cancel-modal" onClick={() => closeModal()}>{t(`${tKey}CLOSE_BTN`)}</Button>
            </Col>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const tKey = 'DOSSIER_COMPONENTS.CAMPAIGNS.CAMPAIGNS_MODAL.VALIDATION.'
  const error = {}
  if (!values.dossierSubTypeId) error.dossierSubTypeId = props.t(`${tKey}FILL_CAMPAIGN_TYPE`)
  return error
}

export default reduxForm({
  form: 'campaign_modal',
  validate
})(CampaignsModal)
